import { InteractiveContainer, Radio } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import React from "react";

export interface SetupMethodOptionProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: React.ReactNode;
  description: React.ReactNode;
  isSelected: boolean;
  onSelect: () => void;
}

export const SetupMethodOption: React.FC<SetupMethodOptionProps> = ({
  icon: Icon,
  title,
  description,
  isSelected,
  onSelect,
}) => (
  <InteractiveContainer
    onClick={onSelect}
    className={cx(
      "flex h-full w-full flex-col rounded-xl border border-solid bg-white p-4 pb-6 transition-colors",
      isSelected ? "border-dark-700" : "border-grey-300"
    )}
  >
    <div className="flex h-full flex-col gap-2.5">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-secondary text-[15px] leading-[150%] font-medium text-black">
          <Icon />
          {title}
        </div>
        <Radio size="md" isChecked={isSelected} readOnly />
      </div>
      <div className="font-secondary text-sm leading-[160%] text-dark-800">
        {description}
      </div>
    </div>
  </InteractiveContainer>
);
